//@ts-nocheck
import React, { PureComponent } from 'react';
import { Icon, Button } from 'antd';
import { actions, services } from '@comall-backend-builder/core';
import { get } from 'lodash';
import classnames from 'classnames';
import {
    Popconfirm as AntPopconfirm,
    Modal as AntModal,
    message as AntMessage,
    Button as AntButton,
} from 'antd';
import QRCode from 'qrcode.react';
import { DESIGN_PAGE_TYPES } from '../../constants/page-design';

const navigation = services.navigation;
const searchAction = actions.searchAction;

const defaultPagePreview = './images/editor/default-page-preview.png';
/**
 * 可视化页面--模板列表项
 */
export class PageTemplateListItem extends PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            hover: false,
        };
    }

    handleEdit = () => {
        const { id } = this.props;
        let path = `/design/template/edit/${id}`;
        navigation.goto(path);
    };
    handleDesign = () => {
        const { id } = this.props;
        let path = `/design/template/design/${id}`;
        navigation.goto(path);
    };
    handlePreview = () => {
        AntModal.info({
            title: '预览',
            content: this.renderPreviewContent(),
            width: 520,
        });
    };

    handleSelect = () => {
        const { parentProps, id, name } = this.props;
        parentProps.onSelected({ id, name });
    };

    copyLink = (url: string) => {
        return function() {
            let input = document.createElement('input');
            input.value = url;
            document.body.appendChild(input);
            input.select();
            if (document.execCommand('Copy')) {
                AntMessage.success('复制成功');
            } else {
                AntMessage.warning('复制失败');
            }
            document.body.removeChild(input);
        };
    };
    renderPreviewContent = () => {
        const classNamePrefix = 'template-preview-modal-wrapper';
        const { preview, name, type, id } = this.props;
        const url =
            ENV.DESIGN_CLIENT_URL + `?page=WYSIWG&template=1&mode=preview&type=${type}&id=${id}`;
        return (
            <div className={classNamePrefix}>
                <div className={`${classNamePrefix}-pic`}>
                    <img alt="预览图" src={preview || defaultPagePreview} />
                </div>
                <div className={`${classNamePrefix}-right`}>
                    <div className={`${classNamePrefix}-name`}>{name}</div>
                    <div className={`${classNamePrefix}-type`}>{get(type, 'name')}</div>

                    <div className={`${classNamePrefix}-code`}>
                        <div className={`${classNamePrefix}-code-description`}>
                            扫描二维码预览
                            <br />
                            或点击
                            <AntButton
                                type="link"
                                style={{ padding: 0 }}
                                className="span-link"
                                onClick={this.copyLink(url)}
                            >
                                复制链接
                            </AntButton>
                            在手机打开
                        </div>
                        <QRCode value={url} />
                    </div>
                </div>
            </div>
        );
    };

    handleDelete = () => {
        const {
            parentProps: { entity },
            id,
        } = this.props;
        entity.delete({ id }, { action: searchAction(entity, {}) });
    };
    render() {
        const { preview, name, type, parentProps } = this.props;
        const { hover } = this.state;
        const enableEdit = get(parentProps, 'type', 'template') === 'template';
        return (
            <div className={classnames('template-item', { hover: hover })}>
                <div className="template-item-preview">
                    <div className={classnames('actions', 'mask')}>
                        {enableEdit && (
                            <Button type="primary" onClick={this.handleDesign}>
                                装饰
                            </Button>
                        )}
                        {!enableEdit && (
                            <Button type="primary" onClick={this.handleSelect}>
                                选择
                            </Button>
                        )}
                        {/* <Button onClick={this.handlePreview}>预览</Button> */}
                    </div>
                    <img alt="预览图" src={preview || defaultPagePreview} />
                </div>
                <div className="template-item-content">
                    <p className="template-item-title">{name}</p>
                    <p className="template-item-extra">{DESIGN_PAGE_TYPES[type]}</p>
                </div>
                {enableEdit && (
                    <ul className="template-item-actions">
                        <li>
                            <AntPopconfirm
                                title="确定删除当前模板吗?"
                                onConfirm={this.handleDelete}
                                okText="确定"
                                cancelText="取消"
                            >
                                <Icon type="delete" title="删除模板" key="delete" />
                            </AntPopconfirm>
                        </li>
                        <li onClick={this.handleEdit}>
                            <Icon type="setting" title="设置模板" key="setting" />
                        </li>
                    </ul>
                )}
            </div>
        );
    }
}
